import { Modal } from '../Modal';
import { Button } from '../Button';

interface ConfirmationModalProps {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
  declineText?: string;
  acceptText?: string;
  children?: JSX.Element | JSX.Element[];
  /** Ignored if children is passed */
  title?: string;
  /** Ignored if children is passed */
  description?: string;
  isLoading?: boolean;
}

export const ConfirmationModal = ({
  open,
  onAccept,
  onDecline,
  acceptText = 'SIM',
  declineText = 'NÃO',
  children,
  title,
  description,
  isLoading,
}: ConfirmationModalProps) => {
  return (
    <Modal open={open}>
      <div className="w-full max-w-sm flex flex-col gap-4 p-4">
        <div>
          {children ? (
            children
          ) : (
            <>
              <h3 className="m-0 mb-1">{title}</h3>
              <p className="m-0">{description}</p>
            </>
          )}
        </div>

        <div className="flex gap-2 justify-end">
          <Button
            size="small"
            circular
            className="w-min whitespace-nowrap"
            onClick={onDecline}
          >
            {declineText}
          </Button>
          <Button
            className="w-min whitespace-nowrap"
            variant="outlined"
            color="secondary"
            onClick={onAccept}
            size="small"
            circular
            isLoading={isLoading}
          >
            {acceptText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
